import React, { useMemo } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import './level_1.css';
import RoomPuzzleLevel from './room_puzzle_level';
import { createEndlessRoom } from './room_puzzle_data';
import { getLevelTime } from './level_time';
import instructions from '../assets/instructions.png';

const getLevelNumber = (pathname) => {
  const match = pathname.match(/^\/level_(\d+)(?:\/|$)/);
  return match ? Number(match[1]) : null;
};

const EndlessRoomLevel = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const levelNumber = getLevelNumber(location.pathname);
  const room = useMemo(
    () => levelNumber ? createEndlessRoom(levelNumber) : null,
    [levelNumber]
  );

  if (!levelNumber || levelNumber < 4) {
    return <Navigate to="/levels" replace />;
  }

  const nextLevel = levelNumber + 1;

  return (
    <RoomPuzzleLevel
      key={levelNumber}
      basePath={`/level_${levelNumber}`}
      backgroundImage={room.backgroundImage}
      className="endless_room_level"
      door={room.door}
      instructionsBackground={instructions}
      instructionsTitle={<>Level {levelNumber}<br />Instructions</>}
      instructionsText={[
        'Move through the room with the arrows and search the wall with the staff light.',
        'Reveal the hidden hieroglyphics, then open the door and enter the code.',
        'Each new room changes the symbols and background, and the timer gets shorter.'
      ]}
      levelTime={getLevelTime(levelNumber)}
      moneyCount={props.moneyCount}
      onComplete={() => {
        props.unlockLevel(nextLevel);
        navigate(`/level_${nextLevel}/wall`);
      }}
      puzzle={room.puzzle}
      setMoneyCount={props.setMoneyCount}
      setShowSettings={props.setShowSettings}
      showInstructionsInitially={levelNumber === 4}
      showSettings={props.showSettings}
    />
  );
};

export default EndlessRoomLevel;
